import { Link } from "gatsby"
import React, { useEffect, useState } from "react"
import { Helmet } from "react-helmet"
import Button from "../../../shared/components/atoms/button/button"
import SearchInputFilterMG from "../../atoms/search-input-filter-mg/search-input-filter-mg"
import CategoryMenuMG from "../category-menu-mg/category-menu-mg"
import "./content-header-mg.scss"

const ContentHeaderMG = props => {
  var imgMobile = props.banner.bannerArticulo[1]
  var imgPc = props.banner.bannerArticulo[0]
  /** hooks */
  const [searchActive, setSearch] = useState(false)
  const [inputValue, setValue] = useState("")
  const [searchInactive, setInactive] = useState(false)
  const [siteTitle] = useState(props.titlePage)
  const [menuCategoryStatus, setStatusMenuCategory] = useState(false)
  const [pageLoad, setPageLoad] = useState(false)
  /** hooks */

  const search = value => {
    props.setnumArticles(props.articleBase)
    props.setSerched(value)
    props.setItemsFilter(
      props.contennInfo.filter(
        info =>
          info.tituloArticulo
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .indexOf(
              value
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
                .trim()
            ) > -1
      )
    )
  }
  const setCloseSearch = () => {
    setSearch(false)
    setInactive(true)
    setTimeout(() => {
      setInactive(false)
    }, 200)
  }

  useEffect(() => {
    setPageLoad(true)
  }, [])

  const filterCategory = value => {
    props.setnumArticles(props.articleBase)
    if (value === "lo-ultimo") {
      props.setItemsFilter(props.infoReal)
      props.setinfoFilter(props.infoReal)
    } else {
      props.setItemsFilter(
        props.infoReal.filter(info =>
          info.categorias.some(
            ({ slug }) => slug.toLowerCase() === value.toLowerCase()
          )
        )
      )
      props.setinfoFilter(
        props.infoReal.filter(info =>
          info.categorias.some(
            ({ slug }) => slug.toLowerCase() === value.toLowerCase()
          )
        )
      )
    }
  }

  if (props.slug === props.activeCategory) {
    return (
      <div className="f-header-container">
        {props.activeCategory  && (
          <div className="f-header-content-section">
            <Helmet>
              <link rel="preload" as="image" href={imgMobile.file.url} />
              <link rel="preload" as="image" href={imgPc.file.url} />
            </Helmet>
            <img
              className="f-header-content-section-img"
              src={props.mobile ? imgMobile.file.url : imgPc.file.url}
              alt={imgPc.description}
              height={
                props.mobile
                  ? imgMobile.file.details.image.height
                  : imgPc.file.details.image.height
              }
            />
            <div className="f-header-content-section-bannerInfo">
              <h1 className="f-main-title">{siteTitle}</h1>
              <span className="f-category-title">{props.titulo}</span>

              <h2 className="f-title-header">{props.banner.tituloArticulo}</h2>

              <a
                className="f-title-botton"
                href={"/magazin/nuestro-mundo/" + props.banner.slug}
              >
                <Button
                  className="primary-blue alter"
                  title={props.banner.ctaBanner}
                />
              </a>
            </div>
          </div>
        )}
        {/* {props.activeCategory === "articulos-usuarias" && (
          <a
            className="f-header-content-section"
            href="/magazin/nuestro-mundo/contenido-usuarias/"
          >
            <img
              className="f-header-content-section-img"
              src={
                pageLoad
                  ? props.mobile
                    ? props.banner2[1].file.url
                    : props.banner2[0].file.url
                  : props.mobile
                  ? props.banner2[1].fixed.base64
                  : props.banner2[0].fixed.base64
              }
              alt={props.banner2[1].description}
              height={
                props.mobile
                  ? props.banner2[1].file.details.image.height
                  : props.banner2[0].file.details.image.height
              }
            />
          </a>
        )} */}
        <div className="f-global-container-mobile">
          <div className="margin-box">
            <div
              className={
                searchActive
                  ? "f-search-component-container menu-search-search-active"
                  : searchInactive
                  ? "f-search-component-container menu-search-search-inactive"
                  : "f-search-component-container"
              }
            >
              <SearchInputFilterMG
                setValue={setValue}
                inputValue={inputValue}
                contennInfo={props.contennInfo}
                search={search}
                searchActive={searchActive}
                setCloseSearch={setCloseSearch}
                setSearch={setSearch}
                mobile={props.mobile}
              />
            </div>
            <CategoryMenuMG
              mobile={props.mobile}
              activeCategory={props.activeCategory}
              categories={props.categories}
              setCategory={props.setCategory}
              persistCategory={props.persistCategory}
              searchActive={searchActive}
              setStatusMenuCategory={setStatusMenuCategory}
              autopauta={props.autopauta}
              filterCategory={filterCategory}
            />

            {props.mobile && (
              <div
                className={
                  menuCategoryStatus
                    ? "f-colapse-menu-category colapse-menu-category-active"
                    : "f-colapse-menu-category colapse-menu-category-inactive"
                }
              >
                <ul>
                  <span
                    onClick={() => setStatusMenuCategory(false)}
                    className="f-icon f-icon-close-colapse icon2-close"
                  ></span>
                  {props.categories.map((categoryItem, index) => {
                    return (
                      <li
                        className="f-category-item"
                        key={index}
                        onClick={() => {
                          filterCategory(categoryItem.slug)
                          setStatusMenuCategory(false)
                          props.setCategory(categoryItem.slug)
                          props.persistCategory(
                            categoryItem.slug,
                            categoryItem.titulo
                          )
                        }}
                      >
                        <h2 className="f-title-category">
                          {categoryItem.titulo}
                        </h2>
                      </li>
                    )
                  })}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  return null
}

export default ContentHeaderMG
